// extracted by mini-css-extract-plugin
export default {"row":"UserForm_row__lnwaZ","backBtn":"UserForm_backBtn__2zdIs","mobilePreview":"UserForm_mobilePreview__CNk1N"};